export default __webpack_public_path__ + "static/media/devices.649d0729.svg";